import { reactive, ref } from 'vue'
const fieldValueType = (fieldType) => {
  if ([1, 4, 5, 6, 8, 9, 10, 13, 17, 21].includes(fieldType)) {
    // 文本  文本域 富文本 单选 图片 附件系统字典 区域 机构字典
    return 'string'
  } else if ([2, 3].includes(fieldType)) {
    // 数字，日期选择
    return 'number'
  } else if (fieldType === 7) {
    // 复选
    return 'array'
  } else {
    return 'string'
  }
}

const spanValue = (fieldType) => {
  if ([1, 2, 3, 6, 10, 13, 17].includes(fieldType)) {
    // 文本 数字 日期 单选 下拉框 系统字典 区域
    return 1
  } else if ([4, 5, 7, 8, 9].includes(fieldType)) {
    // 文本域 富文本 复选 图片 附件
    return 2
  } else {
    return null
  }
}
/**
 * 创建表单的验证规则
 * @param { object } props 表单组件的属性
 * @returns
 */
const getRules = (props) => {
  const formRules = reactive({})
  const createRules = () => {
    let formList = props.meta?.formList || []
    formList.forEach((m) => {
      let array = []
      if (parseInt(m.fieldRequired) === 1) {
        let option = {
          required: true,
          message: `请填写${m.fieldName}`,
          trigger: blur
        }
        array.push(option)
      }

      // 验证规则
      if (m.fieldValidate && m.fieldValidate !== '') {
        if (m.fieldValidateRegular && m.fieldValidateRegular !== '') {
          let regularItem = {
            validator: (rule, value, callback) => {
              if (!value) return callback()
              setTimeout(() => {
                let reg = new RegExp(m.fieldValidateRegular)
                if (!reg.test(value)) {
                  callback(new Error(m.fieldValidateMsg))
                } else {
                  callback()
                }
              }, 500)
            },
            trigger: 'blur'
          }
          array.push(regularItem)
        } else if (![6, 7, 10, 13, 17].includes(parseInt(m.fieldType))) {
          // 单选 复选 下拉框 系统字典 区域
          let regularItem = {
            message: m.fieldValidateMsg,
            type: fieldValueType(parseInt(m.fieldType))
          }
          array.push(regularItem)
        }
      }
      formRules[m.fieldCode] = array
    })
  }
  return { formRules, createRules }
}

/**
 * 处理一个字段占用几个td的需求
 * @param { object } props 表单组件的属性
 * @returns
 */
const getColSpan = (props) => {
  // 确定一个组件占用几个格子
  const formColSpan = reactive({})
  // 根据配置里面的colCount，设置 formColSpan
  const setFormColSpan = () => {
    const { formColCount } = props //列数
    const moreColSpan = 24 / formColCount // 一个格子占多少份
    if (formColCount === 1) {
      // 一列的情况
      props.meta.formList?.forEach((m) => {
        let fieldType = parseInt(m.fieldType)
        if (!spanValue(fieldType)) {
          formColSpan[m.fieldCode] = moreColSpan
        } else {
          if (spanValue(fieldType) >= 1) {
            // 单列，多占的也只有24格
            formColSpan[m.fieldCode] = moreColSpan
          } else if (spanValue(fieldType) < 0) {
            // 挤一挤的情况， 24 除以 占的份数
            formColSpan[m.fieldCode] = moreColSpan / (0 - spanValue(fieldType))
          }
        }
      })
    } else {
      // 多列的情况
      props.meta.formList?.forEach((m) => {
        let fieldType = parseInt(m.fieldType)
        if (!spanValue(fieldType)) {
          formColSpan[m.fieldCode] = moreColSpan
        } else {
          if (spanValue(fieldType) < 0 || spanValue(fieldType) === 1) {
            // 多列，挤一挤的占一份
            formColSpan[m.fieldCode] = moreColSpan
          } else if (spanValue(fieldType) > 1) {
            // 多列，占的格子数 * 份数
            formColSpan[m.fieldCode] = moreColSpan * spanValue(m.fieldType)
          }
        }
      })
    }
  }
  return {
    formColSpan,
    setFormColSpan
  }
}

// 创建组
const getGroup = (props) => {
  const formGroup = reactive([])
  const createGroup = () => {
    let groupList = props.meta.groupList || []
    let formList = props.meta.formList || []
    groupList.forEach((item) => {
      let option = {
        groupId: item.groupCode === -1 ? -1 : item.listGroupId,
        groupName: item.groupName,
        list: []
      }
      if (item.fieldKeys && item.fieldKeys !== '') {
        let strs = item.fieldKeys.split(',')
        strs.forEach((value) => {
          let cm = formList.filter((i) => i.fieldId === value)
          if (cm.length > 0) {
            option.list.push(cm[0])
          }
        })
      }
      formGroup.push(option)
    })
  }
  return {
    formGroup,
    createGroup
  }
}

/**
 * 表单的管理类
 * * 创建v-model
 * * 调整列数
 * * 合并
 */
import { createModel } from './control-model'
const elFormManage = (props, context) => {
  // 设置modelValue的属性
  if (Object.keys(props.modelValue).length === 0) {
    // 根据子控件的meta ,设置默认的model
    if (props.meta.formList) {
      Object.assign(props.modelValue, createModel(props.meta.formList))
    }
  }
  let loadComplete = ref(false)

  const mySubmit = (option) => {
    props.modelValue[option.code] = option.value
    if (props.opType.value == 'add') {
      context.emit('valueChange', {
        fieldCode: option.code,
        fieldName: option.name,
        sysField: option.sysField
      })
    }
  }

  // 一个字段占几个td的对象 设置的函数
  const { formColSpan, setFormColSpan } = getColSpan(props)

  const { formGroup, createGroup } = getGroup(props)

  const { formRules, createRules } = getRules(props)

  const clear = () => {
    loadComplete.value = false
  }

  // 返回重置函数
  props.reset(() => {
    for (let key in props.modelValue) {
      props.modelValue[key] = null
    }
  })

  const loadData = () => {
    createGroup()
    setFormColSpan()
    createRules()
    loadComplete.value = true
    context.emit('complete', true)
  }

  return {
    formGroup, //createGroup
    formColSpan, // 确定组件占位
    formRules, //表单校验规则
    loadComplete, //页面初始化完毕标识符
    loadData, //初始化数据
    mySubmit, //提交
    clear
  }
}
export default elFormManage
